import {useState} from 'react';
import get from 'lodash/get';
import {useNavigate,useParams} from 'react-router-dom';

import useUser from '../../hooks/useUser';
import {useGetAppointmentsQuery} from '../../redux/services/appointmentApi';
import {useGetSessionsQuery} from '../../redux/services/sessionApi';
import AppDashboard from '../AppDashboard';
import ViewSessionScreen from '../../components/sessions/ViewSessionScreen';

const ViewSessionPage = props => {
  const {id} = useParams();
  const [refreshNotePDF, setRefreshPDFNote] = useState(false);
  const [refreshInvoicePDF, setRefreshPDFInvoice] = useState(false);
  const navigate = useNavigate();
  const appointmentQuery = useGetAppointmentsQuery({session_id: id}, {skip: !id});
  const sessionsQuery = useGetSessionsQuery({id}, {skip: !id});
  const user = useUser();
  const childProps = {
    session: (get(sessionsQuery, 'data.data') || []).find(
      s => s.id.toString() === id
    ),
    appointment: (get(appointmentQuery, 'data.data[0]') || null),
    loading: sessionsQuery.isLoading,
    refreshNotePDF,
    refreshInvoicePDF,
    isPatient: get(user, 'is_patient') || false,
    onRefreshNotePDF: () => setRefreshPDFNote(false),
    onRefreshInvoicePDF: () => setRefreshPDFInvoice(false),
    onForceRefreshPDFs: () => {
      setRefreshPDFNote(true);
      setRefreshPDFInvoice(true);
    },
    refetch: () => {
      sessionsQuery.refetch();
      appointmentQuery.refetch();
    },
  };
  return (
    <AppDashboard
      title='Session Details'
      loading={sessionsQuery.isLoading || !user}
      hasNoData={!childProps.loading && !childProps.session}
      onBack={() => navigate('/providers/sessions')}
    >
      <ViewSessionScreen {...childProps} />
    </AppDashboard>
  );
};

export default ViewSessionPage;
